import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <svg
      class="bi"
      [attr.width]="size()"
      [attr.height]="size()"
      [attr.role]="ariaLabel() ? 'img' : null"
      [attr.aria-label]="ariaLabel() || null"
      [attr.aria-hidden]="ariaLabel() ? null : 'true'"
      [attr.fill]="color()"
      [attr.stroke]="strokeColor()"
      [attr.stroke-width]="strokeWidth()"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <use [attr.href]="spriteHref"></use>
    </svg>
  `,
})
export class IconComponent {
  // Inputs principales
  name = input<string>(); // requerido
  size = input<string>('1em');
  spritePath = input<string>('assets/icons/sprite.svg');
  ariaLabel = input<string>();
  color = input<string>('currentColor'); // relleno
  strokeColor = input<string>('currentColor'); // color del trazo
  strokeWidth = input<string | number>('2'); // grosor de línea
  // 👆 puede ser '2' o '0.125em' según el estilo del sprite

  get spriteHref() {
    return `${this.spritePath()}#${this.name()}`;
  }
}
